import enums from '../type/enums';

// These were the old labels for numeric CPU IDs, not chip-family prefixes.
const legacyIds: Record<string, number> = { GD32: 0, AT32: 1, STM32: 2 };

export function normalizeCpuModel<T>(value: T): T | string {
  if (typeof value !== 'string' || !Object.prototype.hasOwnProperty.call(legacyIds, value)) return value;
  return enums.cpu_model[legacyIds[value]];
}

export function normalizeCpuField<T>(key: string, value: T): T | string {
  return key === 'cpu_model' ? normalizeCpuModel(value) : value;
}
